module.exports = __webpack_public_path__ + "kp.svg?fc45ba59283feb5ac07259425091029e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/kp.svg
// module id = 1195
// module chunks = 0